var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.91541 6.78845C1.91541 4.37329 3.87329 2.41541 6.28845 2.41541C8.70362 2.41541 10.6615 4.37329 10.6615 6.78845C10.6615 9.20362 8.70362 11.1615 6.28845 11.1615C3.87329 11.1615 1.91541 9.20362 1.91541 6.78845ZM6.28845 1.125C3.16061 1.125 0.625 3.66061 0.625 6.78845C0.625 9.91629 3.16061 12.4519 6.28845 12.4519C7.46371 12.4519 8.55535 12.0939 9.46029 11.4811L12.5393 14.56C12.9592 14.98 13.6401 14.98 14.06 14.56C14.48 14.1401 14.48 13.4592 14.06 13.0393L10.9811 9.96029C11.5939 9.05535 11.9519 7.96371 11.9519 6.78845C11.9519 3.66061 9.41629 1.125 6.28845 1.125Z","fill":"currentColor"}));
}

Search.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 16 16","fill":"none"};

module.exports = Search;

Search.default = Search;
